/* eslint-disable no-unreachable */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import BookScholarshipSchoolCover from '@cont/BookScholarshipSchool/BookScholarshipSchoolCover';
import Topper from '@cont/BookScholarshipSchool/Toppers';
import FAQSection from '@cont/BookScholarshipSchool/FAQSection';
import {
  getEmailId,
  getFullName,
  getIsLoggedIn,
  getMePhone
} from '@api/selectors/auth';
import { useEffect, useState } from 'react';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import AboutUnacademy from '@cont/BookScholarshipSchool/AboutUnacademy';
import useWindowSize from '@hooks/useWindowSize';
import Image from '@base/Image';
import { Container, ProgressWrapper, StyledDivider } from './styles';
import {
  BottomContainer,
  OuterContainer,
  SachinWrapper
} from '../BookScholarshipSchool/styles';

import { dateContent, modifiedFormData, radioOptions } from './constants';
import BookScholarshipForm from './BookScholarshipForm';
import ResultsAnnoucement from './ResultsAnnoucement';

const defaultFormState = {
  fullName: '',
  phoneNum: '',
  email: '',
  examAndClass: '',
  testType: radioOptions[0],
  city: '',
  centerName: '',
  dateAndTime: ''
};

const defaultSyllabusURL =
  'https://static.uacdn.net/web-cms/UNSAT_Syllabus_Pattern_Non_Schools.pdf';
const BookScholarship = ({
  apiResponse,
  dateSlots,
  nonSchoolFAQHTML,
  cityCenterMapping,
  formDetails
}) => {
  const description = apiResponse?.description
    ? JSON.parse(apiResponse.description)
    : null;
  const { heroForm, features, heroContent, prodigyInfo } = description;

  const { formData } = formDetails || {};
  const [formState, setFormState] = useState(defaultFormState);
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const userFullName = useMyInfo(getFullName);
  const userPhoneNum = useMyInfo(getMePhone);
  const userEmail = useMyInfo(getEmailId);
  const [isRedirecting, setIsRedirection] = useState(false);
  const [isOnlineSelected, setIsOnlineSelected] = useState(false);
  useEffect(() => {
    if (formData?.isFormSubmitted) {
      setFormState(modifiedFormData(formData, dateSlots, cityCenterMapping));
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      setFormState((prevData) => {
        return {
          ...prevData,
          fullName: userFullName,
          phoneNum: userPhoneNum,
          email: userEmail
        };
      });
    }
  }, [userFullName, userPhoneNum, userEmail]);
  const { isMobile } = useWindowSize();
  return <ResultsAnnoucement />;
  if (!description) return;
  if (isRedirecting)
    return (
      <ProgressWrapper>
        <CircularLoader />
      </ProgressWrapper>
    );
  return (
    <BottomContainer>
      <OuterContainer $isOnlineForm>
        <Container>
          <BookScholarshipSchoolCover
            heroContent={heroContent}
            dateContent={dateContent}
            syllabusURL={defaultSyllabusURL}
            isOnlineForm
          />
          <BookScholarshipForm
            heroForm={heroForm}
            dateSlots={dateSlots}
            cityCenterMapping={cityCenterMapping}
            formDetails={formState}
            isRedirecting={isRedirecting}
            setIsRedirection={setIsRedirection}
            isOnlineSelected={isOnlineSelected}
            setIsOnlineSelected={setIsOnlineSelected}
          />
        </Container>
        {isMobile ? (
          <SachinWrapper>
            <Image
              src="offline-centres/sachin-mweb.png"
              layout="fill"
              alt="sachin"
            />
          </SachinWrapper>
        ) : null}
      </OuterContainer>
      <AboutUnacademy
        features={features}
        isOnlineSelected={isOnlineSelected}
        isOnlineForm
      />
      <Topper prodigyInfo={prodigyInfo} />
      <FAQSection contentFAQs={nonSchoolFAQHTML} />
      <StyledDivider />
    </BottomContainer>
  );
};

BookScholarship.propTypes = {
  apiResponse: PropTypes.objectOf(PropTypes.any).isRequired
};

export default BookScholarship;
